import {useState} from 'react'
import {announce} from '@github-ui/aria-live'
import {Banner} from '@primer/react'
import {
  MergeQueueError,
  type MergeQueueErrorDetails,
} from '@github-ui/mergebox/components/sections/merge/MergeQueueError'
import styles from './ForYouItemContent.module.css'

export function useForYouActionErrors() {
  const [updateError, setUpdateError] = useState<string | null>(null)
  const [queueError, setQueueError] = useState<MergeQueueErrorDetails | null>(null)
  const hasQueueError = !!(queueError?.message || queueError?.ruleErrors?.length)

  const onUpdateBranchError = (message: string | null) => {
    setUpdateError(message)
    if (message) announce(message, {assertive: true})
  }

  return {
    onUpdateBranchError,
    onQueueError: setQueueError,
    footer:
      updateError || hasQueueError ? (
        <div className={styles.ActionErrors}>
          {updateError && (
            <Banner variant="critical" title="Error" hideTitle>
              {updateError}
            </Banner>
          )}
          {queueError && <MergeQueueError error={queueError} />}
        </div>
      ) : null,
  }
}
